import axios from './request'
import config from '@/config'

let baseURL = config.baseURL
let baseContext = config.baseContext
let accessKeyID = config.accessKeyID
let accessKey = config.accessKey
let headers = {
  appType: 4,
  userId : localStorage.getItem('login_userid_app'),
  userToken : localStorage.getItem('login_token_app')
}
const TIME_OUT = 5000;

const API = {
  getBaseContext () {
    return baseContext
  },
  getAccessInfo () {
    return {
      accessKey: accessKey,
      accessKeyID: accessKeyID
    }
  },
  getBaseUrRl () {
    return baseURL
  },
  //用户昵称头像
  getuser(param) {
    let url = baseURL + 'user/userService/userInfo'
    // console.log(param)
    return axios.post(url, '', { headers: param.headers })
  },
  //获取分享信息
  queryShareInfo(param){
    let url = baseURL + '/user/shareInfo/queryShareInfo'
    return axios.post(url, param,{headers:param.header})
  },
  //获取手机号
  getuserinfo(param){
    let url = baseURL+'h5/inviteNew/v1.0.0.7/queryshareUserInfo'
    return  axios.post(url , '' , {headers:param.headers})
  },
  //经分统计：登录权益
  postJinFenLogin (param) {
    let url = baseURL + '/user/userService/createUserLoginInfo'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //经分统计：添加事件
  postJinFenEvent (param) {
    // let url = baseURL + '/report/bilog/addClientEvent'
    let url = baseURL + 'h5/bilog/addClientEvent'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //获取活动奖品
  getAllList(param){
    let url = baseURL + 'h5/lottery/listPrizes';
    return axios.post(url, param.data, {})
  },
  //获取活动时间
  getTimes(param){
    let url = baseURL + 'h5/activityConf/getActivityDate/'+param.data.activityMark+''
    return axios.post(url, {}, {timeout: TIME_OUT})
  },
  //点击抽奖接口
  draw(param){
    let url = baseURL + '/h5/lottery/draw'
    return axios.post(url, param.data, { headers: param.headers, timeout: TIME_OUT })
  },
  //获取获奖用户列表
  getUserList(param){
    let url = baseURL + 'h5/lottery/marquee'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //获取用户是否有优惠券
  getDiscountStatus(param){
    let url = baseURL + 'member/userCoupon/v1.0.3.4/getDiscountStatus'
    return axios.post(url, param.data, {headers:param.headers})
  },
  //获取抽奖次数
  getLotteryNumber(param){
    let url = baseURL + 'h5/lottery/getLotteryNumber'
    return axios.post(url, param.data, { headers: param.headers, timeout: TIME_OUT })
  },
   //规则常见问题
  queryCopyWriting(param){
    let url = baseURL + 'game/copywriting/v1.0.2.5/queryCopyWriting'
    return axios.post(url, param.data, { headers:param.headers  })
  },
   //我的奖品列表
  queryPrizeList(param){
    let url = baseURL + 'h5/lottery/listLotteryRecord'
    return axios.post(url, param.data, { headers:param.headers  })
  },
   //实物奖品地址查询
   getMyAddress(param){
    let url = baseURL + 'h5/address/v1.0.4.8/queryActivityAddress'
    return axios.post(url, param.data, { headers:param.headers  })
  },
   //提交收货地址
   saveMyAddress (param) {
    let url = baseURL + 'h5/address/v1.0.4.8/submitActivityAddress'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //获取数据库时间
  getDBTime() {
    let url = baseURL + 'game/marketingClient/v1.0.0.4/queryDbSysdate'
    return axios.post(url, { })
  },
}

export default API



// WEBPACK FOOTER //
// ./src/api/double12.js